import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ↓ Typescript 적용 전 코드
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//       <App />
// );

// ↓ Typescript 적용 후 코드 (Typescript는 null을 직접 사용할 수 없으므로, 안전하게 접근할 수 있도록 확인하는 절차를 추가)
const rootElement = document.getElementById('root');
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(<App />);
} else {
    console.error('Root element not found');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
